import { render, staticRenderFns } from "./ListFiltroModalItem.vue?vue&type=template&id=8585e5aa"
import script from "./ListFiltroModalItem.vue?vue&type=script&lang=js"
export * from "./ListFiltroModalItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports